export interface ComicChapter {
  id: number;
  title: string;
  date: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  status: string;
  updatedAt: string;
  chapters: ComicChapter[];
  featured: boolean;
  isNew: boolean;
  isHot: boolean;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Dubu',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20style%20dark%20fantasy%20hunter%20warrior%20with%20glowing%20blue%20eyes%20holding%20dagger%2C%20dramatic%20lighting%2C%20action%20pose%2C%20anime%20art%20style%2C%20clean%20composition%2C%20minimal%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '十多年前，世界各地突然出现了连接异次元与现实世界的"门"，同时觉醒了一群被称为"猎人"的超能力者。然而并非所有猎人都同样强大——身为E级猎人的成振宇，被戏称为"人类最弱兵器"。在一次濒死体验后，他获得了神秘系统的能力，可以无限升级变强。从此，一场从最弱到最强的进化之旅就此展开...',
    category: 'action',
    tags: ['热血', '奇幻', '系统流'],
    rating: 9.7,
    views: 2850000,
    status: '已完结',
    updatedAt: '2026-07-28',
    chapters: [
      { id: 1, title: '第1话 - 最弱猎人', date: '2026-07-28' },
      { id: 2, title: '第2话 - 系统激活', date: '2026-07-28' },
      { id: 3, title: '第3话 - 每日任务', date: '2026-07-27' },
      { id: 4, title: '第4话 - 地下城突袭', date: '2026-07-27' },
      { id: 5, title: '第5话 - 狼群之王', date: '2026-07-26' },
    ],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 2,
    title: '全知读者视角',
    author: 'Sing Shong / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20omniscient%20reader%20viewpoint%20style%20young%20man%20with%20books%20and%20magical%20constellations%2C%20mysterious%20atmosphere%2C%20fantasy%20anime%20art%2C%20soft%20diffused%20lighting%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '金独子是一个平凡的上班族，唯一的爱好是阅读一部名为《在灭亡世界生存的三种方法》的网络小说。这部小说连载了十年，只有他一个读者追到了最终话。然而就在完结那天，小说中的场景竟然在现实中上演了——他成为了唯一知道这个世界结局的人。凭借着对剧情的了解，他将在这末日世界中开辟属于自己的生存之路。',
    category: 'fantasy',
    tags: ['奇幻', '末世', '智斗'],
    rating: 9.5,
    views: 2180000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 - 唯一读者', date: '2026-08-02' },
      { id: 2, title: '第2话 - 付费结算', date: '2026-08-02' },
      { id: 3, title: '第3话 - 第一幕开始', date: '2026-08-01' },
    ],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 3,
    title: '她的私生活',
    author: '金作家',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20style%20beautiful%20woman%20and%20handsome%20man%20close%20together%2C%20soft%20pink%20tones%2C%20romantic%20atmosphere%2C%20floating%20cherry%20blossom%20petals%2C%20anime%20art%20style%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '成德美是一位美术馆的首席策展人，表面上是完美的职场精英女性。然而她隐藏着一个秘密——她私下里是一个男团偶像的狂热粉丝站站长。当新馆长莱恩·金发现她的双重身份后，两人之间展开了一段既爆笑又温暖的故事。职业与追星、工作与热爱，她能否找到平衡？',
    category: 'romance',
    tags: ['恋爱', '职场', '喜剧'],
    rating: 9.2,
    views: 1560000,
    status: '已完结',
    updatedAt: '2026-06-15',
    chapters: [
      { id: 1, title: '第1话 - 完美策展人', date: '2026-06-15' },
      { id: 2, title: '第2话 - 新馆长', date: '2026-06-15' },
    ],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 4,
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20tower%20of%20god%20style%20mysterious%20tall%20tower%20reaching%20sky%2C%20boy%20climbing%20with%20determination%2C%20fantasy%20world%2C%20anime%20art%2C%20dramatic%20composition%2C%20minimal%20clean%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '二十五夜是一名普通的少年，他追逐着唯一的朋友蕾哈尔进入了神之塔。这座塔据说可以满足登顶者的任何愿望。每一层都是一场考验，从简单的战斗到复杂的心理博弈，二十五夜在攀登过程中不断成长，结识伙伴，也逐渐揭开了塔背后隐藏的巨大秘密。',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '友情'],
    rating: 9.4,
    views: 3200000,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 - 追逐星星的男孩', date: '2026-08-01' },
      { id: 2, title: '第2话 - 第一层考验', date: '2026-07-31' },
      { id: 3, title: '第3话 - 王冠游戏', date: '2026-07-31' },
    ],
    featured: true,
    isNew: false,
    isHot: false,
  },
  {
    id: 5,
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20lookism%20style%20two%20sides%20of%20same%20person%2C%20one%20handsome%20one%20ordinary%2C%20split%20face%20composition%2C%20school%20uniform%2C%20dramatic%20contrast%2C%20anime%20art%2C%20minimal%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '朴亨硕是一个因为外貌而长期遭受校园霸凌的高中生。某天他醒来时发现，自己竟然拥有了另一副完美的身体——高大帅气、体能出众。从此他过上了双重生活：白天是帅气的新生，晚上回到原本矮胖的身体。这部作品深刻探讨了外貌歧视、校园暴力和韩国社会中的"看脸"文化。',
    category: 'drama',
    tags: ['校园', '社会', '成长'],
    rating: 9.3,
    views: 4100000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 - 新身体', date: '2026-08-03' },
      { id: 2, title: '第2话 - 转学生', date: '2026-08-03' },
    ],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 6,
    title: '女神降临',
    author: '喵喵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20true%20beauty%20style%20girl%20transforming%20from%20plain%20to%20beautiful%20with%20makeup%2C%20glamorous%20vibe%2C%20anime%20art%20style%2C%20sparkling%20effect%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '林周京从小因为长相平凡而自卑，经常被同学嘲笑。在绝望中她发现了化妆的魔力——通过精湛的化妆技巧，她摇身一变成为了校园女神。然而她时刻担心秘密被揭穿。当全校最帅的两个男生同时对她产生好感时，她的双重身份变得更加难以维持。这是一部关于美丽、自信与真爱的青春罗曼史。',
    category: 'romance',
    tags: ['恋爱', '校园', '美妆'],
    rating: 9.1,
    views: 3800000,
    status: '已完结',
    updatedAt: '2026-05-20',
    chapters: [
      { id: 1, title: '第1话 - 化妆的力量', date: '2026-05-20' },
      { id: 2, title: '第2话 - 校园女神诞生', date: '2026-05-20' },
    ],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 7,
    title: '重生之都市修仙',
    author: '柳下挥',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cultivation%20style%20young%20man%20with%20spiritual%20energy%20surrounded%20by%20blue%20aura%2C%20modern%20city%20background%2C%20fantasy%20anime%20art%2C%20dynamic%20pose%2C%20clean%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '北玄仙尊重生回到了五百年前的地球——一个灵气稀薄的末法时代。前世他横扫宇宙、纵横万界，如今却要在这个灵气匮乏的星球上重新开始。凭借着前世的修仙经验和万般法术，他在现代都市中一步步崛起。从校园到商场，从地下世界到国际舞台，他将再次踏上巅峰之路。',
    category: 'action',
    tags: ['修仙', '都市', '重生'],
    rating: 9.0,
    views: 1950000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 - 仙尊重生', date: '2026-08-03' },
      { id: 2, title: '第2话 - 淬体入门', date: '2026-08-02' },
    ],
    featured: false,
    isNew: true,
    isHot: true,
  },
  {
    id: 8,
    title: '丧尸校园',
    author: '朱东根',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20zombie%20thriller%20manhwa%20style%20students%20trapped%20in%20school%20with%20zombies%20approaching%2C%20tense%20atmosphere%2C%20dark%20hallway%2C%20survival%20horror%2C%20anime%20art%2C%20dramatic%20lighting&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '孝山高中，原本只是首尔一所普通的学校。某天一个被感染的学生闯入校园，病毒以惊人的速度蔓延。被困在学校里的师生们必须在与外界隔绝的情况下设法生存。没有武器、没有食物、没有外援，他们能否在丧尸潮中杀出一条血路？人性的善恶在极端环境下被彻底考验。',
    category: 'thriller',
    tags: ['丧尸', '生存', '校园'],
    rating: 9.0,
    views: 2650000,
    status: '已完结',
    updatedAt: '2026-04-10',
    chapters: [
      { id: 1, title: '第1话 - 第一例感染者', date: '2026-04-10' },
      { id: 2, title: '第2话 - 封锁', date: '2026-04-10' },
    ],
    featured: true,
    isNew: false,
    isHot: false,
  },
  {
    id: 9,
    title: '废柴重生记',
    author: '白熊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20style%20funny%20loser%20character%20with%20exaggerated%20expression%2C%20bright%20colorful%20comedy%20vibe%2C%20anime%20art%2C%20playful%20composition%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '李平凡，一个活了二十多年一事无成的超级废柴。某天因为意外穿越到了一个剑与魔法的异世界。在这里他意外获得了"废柴系统"——越废柴越强大！练废了就变强，摆烂才是正道。在一群正经冒险者的包围中，他用自己独特的废柴方式拯救世界，笑料百出。',
    category: 'comedy',
    tags: ['搞笑', '异世界', '系统流'],
    rating: 8.8,
    views: 1250000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 - 废柴穿越', date: '2026-08-02' },
      { id: 2, title: '第2话 - 废柴系统的真相', date: '2026-08-01' },
    ],
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 10,
    title: '拳击手',
    author: 'JH',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20boxing%20style%20young%20fighter%20with%20boxing%20gloves%20in%20ring%2C%20intense%20expression%2C%20dramatic%20lighting%2C%20sweat%20and%20determination%2C%20anime%20art%2C%20minimal%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '金宇是一名高中辍学生，为了还清母亲的医疗债务，他走上了地下拳击的道路。在地下拳场，没有规则、没有保护，只有最原始的暴力。他凭借着惊人的天赋和顽强的意志，从最底层一步步打到金字塔顶端。但成为最强拳击手的代价是什么？残酷的地下世界正在等待着他。',
    category: 'action',
    tags: ['格斗', '热血', '励志'],
    rating: 9.2,
    views: 1780000,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 - 地下拳场', date: '2026-08-01' },
      { id: 2, title: '第2话 - 第一战', date: '2026-07-31' },
    ],
    featured: true,
    isNew: false,
    isHot: false,
  },
  {
    id: 11,
    title: '奇妙诊所',
    author: '尹美静',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20medical%20manhwa%20style%20kind%20doctor%20in%20small%20clinic%2C%20warm%20atmosphere%2C%20healing%20vibe%2C%20anime%20art%2C%20soft%20lighting%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '在一座安静的海边小镇上，有一家名为"奇妙诊所"的小诊所。这里的医生并非用传统药物治疗疾病，而是通过倾听患者的故事来治愈心灵。每一个前来就诊的人都有一个不为人知的秘密和伤痛。医生用他独特的方式——也许是陪伴、也许是引导——帮助他们找到内心的力量。',
    category: 'drama',
    tags: ['治愈', '人情', '单元剧'],
    rating: 9.4,
    views: 980000,
    status: '已完结',
    updatedAt: '2026-03-15',
    chapters: [
      { id: 1, title: '第1话 - 失眠的作曲家', date: '2026-03-15' },
      { id: 2, title: '第2话 - 沉默的孩子', date: '2026-03-14' },
    ],
    featured: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 12,
    title: '恶魔的契约',
    author: '暗夜公爵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20style%20mysterious%20man%20making%20contract%20with%20demonic%20shadow%2C%20dark%20gothic%20atmosphere%2C%20red%20accents%2C%20anime%20art%2C%20dramatic%20composition%2C%20minimal%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '姜贤宇是一个因意外失去一切的普通上班族。在他人生最低谷时，一个神秘人找上门来，递给他一份契约——以灵魂为代价，可以实现任何一个愿望。他许下了让时光倒流的愿望，却发现自己被困在了一个不断循环的噩梦之中。每个循环中死去的人越来越多，他开始怀疑这份契约背后隐藏着更大的阴谋。',
    category: 'thriller',
    tags: ['悬疑', '超自然', '时间循环'],
    rating: 9.1,
    views: 1420000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 - 契约', date: '2026-08-03' },
      { id: 2, title: '第2话 - 第一个轮回', date: '2026-08-02' },
    ],
    featured: false,
    isNew: true,
    isHot: true,
  },
];

export const collections = [
  {
    id: 1,
    title: '热血战斗精选',
    description: '拳拳到肉、酣畅淋漓的战斗场面，让你一次看过瘾',
    comicIds: [1, 10, 7],
  },
  {
    id: 2,
    title: '甜蜜恋爱特辑',
    description: '甜蜜心动、纯爱体验，韩漫恋爱作品的巅峰之作',
    comicIds: [3, 6],
  },
  {
    id: 3,
    title: '烧脑悬疑合辑',
    description: '层层反转、细思极恐，挑战你的推理能力',
    comicIds: [8, 12],
  },
  {
    id: 4,
    title: '异世界幻想精选',
    description: '天马行空的想象，带你领略不一样的世界观',
    comicIds: [2, 4, 9],
  },
];

export const reviews = [
  {
    id: 1,
    name: '漫画爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    rating: 5,
    comment: '这个网站真的太棒了！更新速度很快，翻译质量也很高。我每天都会来刷一遍，看看有没有新的章节更新。强烈推荐给所有韩漫爱好者！',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20woman%20portrait%2C%20gentle%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    rating: 5,
    comment: '找了很久的韩漫阅读平台，终于找到了这里。分类很清晰，推荐也很精准，总是能找到我喜欢类型的作品。界面简洁大方，阅读体验一流！',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '漫游者老李',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Asian%20man%20portrait%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    rating: 4,
    comment: '作为一个看了十几年漫画的老读者，对韩漫的要求还是比较高的。这个网站的作品选择很用心，不是那种随便堆砌内容的站。特别推荐精选合集功能，帮我发现了很多冷门神作。',
    date: '2026-07-20',
  },
];